export default {
    title: "Delete Dependent",
    type: "object",
    required: ["terminateDate", "relationshipTermReasonId"],
    properties: {
        terminateDate: {
            type: "string",
            format: "date",
            title: "Relationship End Date"
        },
        relationshipTermReasonId: {
            type: "number",
            title: "Reason",
            enum: [],
            enumNames: [] 
        },
        enrollmentPackageId: {
            type: "number",
            title: " "
        }
    }
};